module.exports = __webpack_public_path__ + "img/panic.c6d4fefd.svg";